import { parsePostprocessingTemplate } from '@/utils/postprocessingTemplateHelpers';

type PostprocessingItem = {
  name: string;
  params: Record<string, any>;
  [key: `algorithm_${string}`]: any;
};

type MeasurementMeta = {
  nm?: number;
};

type Measurement = {
  id: number;
  name: string;
  type: string;
  meta?: MeasurementMeta;
  processing_state: string;
  postprocessings: PostprocessingItem[];
};

type InputData = {
  measurements: Measurement[];
};

type TransformedPostprocessing = {
  algorithm: any;
  [key: string]: any;
};

type OutputMeasurement = {
  id: number;
  name: string;
  type: string;
  waveLength?: number;
  processing_state: string;
};

type ParsedMeasurement = {
  measurement: OutputMeasurement;
  postprocessings: Record<string, TransformedPostprocessing>;
};

export const parseMeasurementsWithPostprocessing = (data: InputData): ParsedMeasurement[] => {
  console.warn('data?.measurements', data, data?.measurements);
  return data?.measurements.map((measurement) => {
    const transformedPostprocessings = Object.fromEntries(
      measurement.postprocessings.map(({ name, params, ...algorithms }) => [
        name,
        {
          algorithm: algorithms[`algorithm_${name.toLocaleLowerCase()}`],
          ...params,
        },
      ]),
    );
    return {
      measurement: {
        id: measurement.id,
        name: measurement.name,
        type: measurement.type,
        waveLength: measurement.meta?.nm,
        processing_state: measurement.processing_state,
      },
      postprocessings: transformedPostprocessings,
    };
  });
};

type AppliedPostprocessings = {
  PDET: TransformedPostprocessing;
  PEAK: TransformedPostprocessing;
  BASE: TransformedPostprocessing;
  BINJ: TransformedPostprocessing;
  NOIS: TransformedPostprocessing;
  DTIM: TransformedPostprocessing;
};

export const getPostprocessingFlat = (appliedPostprocessings: AppliedPostprocessings) => {
  return parsePostprocessingTemplate({
    algorithm_pdet: appliedPostprocessings.PDET.algorithm,
    algorithm_peak: appliedPostprocessings.PEAK.algorithm,
    algorithm_base: appliedPostprocessings.BASE.algorithm,
    algorithm_binj: appliedPostprocessings.BINJ.algorithm,
    algorithm_nois: appliedPostprocessings.NOIS.algorithm,
    ...appliedPostprocessings.PDET,
    ...appliedPostprocessings.PEAK,
    ...appliedPostprocessings.BASE,
    ...appliedPostprocessings.BINJ,
    ...appliedPostprocessings.NOIS,
    ...appliedPostprocessings.DTIM,
  });
};
